module.exports = __webpack_public_path__ + "img/picture_19.e0d28ae6.png";